module.exports = __webpack_public_path__ + "img/3-low.427fb476.jpg";